import { render } from "./viewMailing.html?vue&type=template&id=596396fc&scoped=true&ts=true&external"
import script from "./ViewMailing.vue?vue&type=script&lang=ts"
export * from "./ViewMailing.vue?vue&type=script&lang=ts"

import "./ViewMailing.vue?vue&type=style&index=0&id=596396fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596396fc"]])

export default __exports__